<template>
  <v-navigation-drawer
    v-model="drawer"
    :app="isRoot"
    :clipped="isRoot"
    :absolute="!isRoot"
    dense
    class="main"
  >
    <template
      v-for="(subNavigationMenu,
      subNavigationMenuName) in navigationNode.navigationNodes"
    >
      <Navigation
        :address="[...address, subNavigationMenuName]"
        v-bind:key="'Navigation' + address.join('') + subNavigationMenuName"
        v-if="subNavigationMenu.items && subNavigationMenu.items.length"
      />
    </template>

    <v-list dense>
      <v-list-item v-on:click="disActivateSubNavigate()" v-if="!isRoot">
        <v-list-item-action>
          <v-icon color="primary">mdi-arrow-left</v-icon>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="!isRoot"></v-divider>

      <template v-for="(item, i) in navigationNode.items">
        <v-list-item
          v-bind:key="i"
          v-if="!item.items"
          :to="item.to"
          v-on:click="activateSubNavigate(item.activate)"
          active-class="list-item-active"
          v-ripple="false"
          :exact="item.exact"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              :class="{
                'list-item-title-with-button': item.specialTo
              }"
              >{{ item.title() }}
              <v-btn
                v-if="item.specialTo"
                class="list-title-special-to"
                v-on:click.stop.prevent="$router.push(item.specialTo)"
                depressed
                absolute
                right
                icon
                small
                :color="item.specialTo.active ? 'primary' : ''"
              >
                <v-icon>{{ item.specialIcon || "mdi-swap-horizontal" }}</v-icon>
              </v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          v-bind:key="i"
          v-else
          no-action
          active-class="list-item-active"
          :value="item.drawer"
        >
          <!--          Todo: need to think how it can be better-->
          <template v-slot:activator>
            <div
              class="d-flex"
              style="width: 100%;"
              v-on:click="$router.push(item.to)"
            >
              <v-list-item-action v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title() }}</v-list-item-title>
              </v-list-item-content>
            </div>
          </template>

          <template v-for="(subItem, u) in item.items">
            <v-list-item
              v-bind:key="u"
              :to="subItem.to"
              v-if="!subItem.items"
              v-on:click="activateSubNavigate(subItem.activate)"
              active-class="list-item-active"
              v-ripple="false"
              :class="{
                'list-item-active': checkSubTo(subItem),
                'v-list-item--active': checkSubTo(subItem)
              }"
            >
              <v-list-item-action v-if="subItem.icon">
                <v-icon>{{ subItem.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ subItem.title() }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group
              :value="subItem.drawer"
              v-else
              v-bind:key="u"
              no-action
              sub-group
            >
              <template v-slot:activator>
                <v-list-item-title>{{ subItem.title() }}</v-list-item-title>
              </template>

              <template v-for="(subSubItem, y) in subItem.items">
                <v-list-item
                  v-bind:key="y"
                  :to="subSubItem.to"
                  active-class="list-item-active"
                >
                  <v-list-item-action v-if="subSubItem.icon">
                    <v-icon>{{ subSubItem.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      subSubItem.title()
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider
                  v-if="subSubItem.divider"
                  v-bind:key="y + 'divider'"
                />
              </template>
            </v-list-group>
            <v-divider v-if="subItem.divider" v-bind:key="u + 'divider'" />
          </template>
        </v-list-group>

        <v-divider v-if="item.divider" v-bind:key="i + 'divider'" />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Navigation",
  data: () => ({
    right: false
  }),
  props: {
    address: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    drawer: {
      get() {
        return this.navigationNode.drawer;
      },
      set(value) {
        this.$store.dispatch("navigationStore/setActivateNavigationNode", {
          address: [...this.address],
          drawer: value
        });
      }
    },
    navigationNode: {
      get() {
        return this.$store.getters["navigationStore/getNavigationNode"]([
          ...this.address
        ]);
      }
    },
    isRoot: function() {
      return !(this.address && this.address.length > 0);
    }
  },
  methods: {
    activateSubNavigate(navigateName) {
      if (navigateName) {
        this.$store.dispatch("navigationStore/activateNavigationNode", {
          address: [...this.address, navigateName]
        });
      }
    },
    disActivateSubNavigate() {
      this.$store.dispatch("navigationStore/disActivateNavigationNode", {
        address: [...this.address]
      });
    },
    checkSubTo(subItem) {
      return (Array.isArray(subItem.subTo)
        ? subItem.subTo
        : [subItem.subTo]
      ).find(route => this.$route.name === (route || {}).name);
    },
    checkTo(subItem) {
      return this.$route.name === subItem.to;
    }
  }
};
</script>

<style lang="scss" scoped>
.list-item-active {
  color: rgba(0, 0, 0, 0.87) !important;
  & > * {
    color: #db2828;
  }
}
.main::v-deep .v-list-item--link {
  &:before {
    color: rgba(0, 0, 0, 0.87) !important;
  }
  .v-ripple__container {
    display: none;
  }
}
.list-title-special-to {
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  &::v-deep .v-icon {
    font-size: 20px;
  }
}
.list-title-special-to:hover:before {
  background: transparent;
}
.list-title-special-to:before {
  background: transparent;
}
.list-item-title-with-button {
  padding-right: 28px;
}
.list-title-special-to.v-btn--active .v-icon {
  color: #db2828;
}
</style>
